import request from '@/utils/request'
import base from "@/api/base";

export default {
    // 发布官方产样
    save: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/product/saveProduct`, params),
    //获取官方产样列表
    get: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/product/getProductList`, params),
    //修改官方产样
    update: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/product/updateProduct`, params),
    //删除官方产样
    del: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/product/deleteProduct`, params),
    //获取官方编号
    bhget: params => request.get(`${base.baseUrl}/yyyhao-cloud-product/product/generateLastOuterKey`, params),
    //获取草稿箱列表
    cgx: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/product/getDraftList`, params),
    //删除草稿
    dels: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/product/deleteDraft`, params),
}